export const DD_SAVED_FILTER_APPLY = "saved-filter-apply";

export const DD_SAVED_FILTER_DELETE = "saved-filter-delete";

export const DD_SAVED_FILTER_SHARE = "saved-filter-share";
